module.exports = __webpack_public_path__ + "img/grazi_menu_2.744fe843.png";